import React, { memo, useContext, useCallback } from 'react';
import { PAYMENT_METHOD } from '../../../../commons/utils/constants';
import useI18n from '../../../../i18n/hooks/useI18n';
import TransactionContext from '../contexts/TransactionContext';
import TabsContext from '../contexts/TabsContext';
import { TAB_TYPE_BUYING } from '../../constants';
import S from './style/DesktopTransactionInfo';
import { type DeliveryType } from '../../../../../typings/transaction';

interface DesktopTransactionInfoProps {
  deliveryType?: DeliveryType;
}

const DesktopTransactionInfo: React.FC<DesktopTransactionInfoProps> =
  function DesktopTransactionInfo({ deliveryType = 'P2P' }) {
    const i18n = useI18n();
    const i18nKey = useCallback(key => i18n(`dlv_orders_details_${key}`), [i18n]);
    const { paymentMethod, buyer, seller } = useContext(TransactionContext) || {};
    const tabType = useContext(TabsContext);

    const user = tabType === TAB_TYPE_BUYING ? seller : buyer;
    const getDeliveryMethod = { P2P: 'point_to_point', D2D: 'door_to_door' };

    return (
      <S.TransactionInfo>
        <S.InfoBlock>
          <S.InfoBlockTitle>{i18nKey`deliverymethod`}</S.InfoBlockTitle>
          <S.InfoBlockContent data-testid={`delivery-method-${deliveryType.toLowerCase()}-enabled`}>
            {i18nKey(getDeliveryMethod[deliveryType])}
          </S.InfoBlockContent>
        </S.InfoBlock>
        <S.InfoBlock>
          <S.InfoBlockTitle>{i18nKey`paymentmethod`}</S.InfoBlockTitle>
          <S.InfoBlockContent>
            {paymentMethod && (
              <>
                {paymentMethod === PAYMENT_METHOD.cod
                  ? i18nKey`cash_on_delivery`
                  : i18nKey`online_payment`}
              </>
            )}
          </S.InfoBlockContent>
        </S.InfoBlock>
        <S.InfoBlock>
          <S.InfoBlockTitle data-testid="desktop-transaction-counterpart">
            {tabType === TAB_TYPE_BUYING ? i18nKey`seller` : i18nKey`buyer`}
          </S.InfoBlockTitle>
          <S.InfoBlockContent>{user?.name}</S.InfoBlockContent>
          {user?.phone && <S.InfoBlockContent>{user?.phone}</S.InfoBlockContent>}
        </S.InfoBlock>
      </S.TransactionInfo>
    );
  };

export default memo(DesktopTransactionInfo);
